// removed by extract-text-webpack-plugin
module.exports = {"searchHighlight":"_1oXIOBBmSuM-hnO5PleIe_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-style-loader!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/style-compiler?{"id":"data-v-1c7f2994","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Contacts.vue
// module id = 1021
// module chunks = 1